// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T21:42:56.434Z
// Property: Hunters Oak Apartments (ID: 6767906449167516)
// Collections: 22 amenities, 2 floorplans (live), 22 photos, 35 POIs, 2 reviews, 4 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167516",
  "property_external_id": "5685515",
  "property_zillow_url": "https://www.zillow.com/apartments/greenville-oh/hunters-oak-apartments/Ch2fZ4/",
  "property_apartments_url": "https://www.apartments.com/hunters-oak-apartments-greenville-oh/lwc4dmd/",
  "property_google_business_url": "https://www.google.com/maps/place/Hunters+Oak+Apartments/@40.11968,-84.6161873,906m/data=!3m2!1e3!4b1!4m6!3m5!1s0x883feb462b36d68f:0xb5285db9aa099e5e!8m2!3d40.11968!4d-84.6161873!16s%2Fg%2F1tqpzy3s?entry=ttu&g_ep=EgoyMDI2MDUyNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "58528500258",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "hunters-oak-apartments",
  "property_name": "Hunters Oak Apartments",
  "property_website_url": "https://www.huntersoakapartmentliving.com/",
  "property_domain": "https://www.huntersoakapartmentliving.com/",
  "property_address": "1199 Russ Rd",
  "property_full_address": "1199 Russ Rd, Greenville, OH 45331",
  "property_address_1": "1199 Russ Rd",
  "property_address_2": null,
  "property_address_city": "Greenville",
  "property_address_state": "OH",
  "property_address_zip_full": "45331-9523",
  "property_address_zip": "45331",
  "property_address_country": "US",
  "property_address_county": "Darke County",
  "property_neighborhood_address": "Ohio South Area",
  "property_address_latitude": "40.1198527",
  "property_address_longitude": "-84.6168417",
  "property_email": "huntersoak@dietzpropertygroup.com",
  "property_phone": "(937) 316-6667",
  "property_call_tracking_phone": "937-316-6667",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://www.dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Hunters Oak in Greenville, OH, our thoughtfully designed two- and three-bedroom apartments offer a blend of comfort and style. With pet-friendly amenities and a vibrant community atmosphere, you’ll find the perfect home here. Find your new home today—browse our availability or schedule a tour to experience Hunters Oak!",
  "property_long_description": "**Welcome to Hunters Oak – Your Ideal Home in Greenville, OH!**\n\nDiscover the perfect blend of comfort and convenience at Hunters Oak, where we offer a variety of beautifully designed floor plans, including spacious two-bedroom and three-bedroom apartments. Whether you’re searching for a cozy retreat or a vibrant living space for your family, our thoughtfully laid out apartments cater to all your lifestyle needs. Each residence boasts modern finishes and ample natural light, creating a warm and inviting atmosphere you’ll love coming home to.\n\nAt Hunters Oak, we prioritize your comfort with a wide array of apartment amenities designed for modern living. Enjoy the convenience of pet-friendly options, ensuring that your furry friends feel right at home alongside you. Our community offers everything you need for a quality lifestyle, from well-maintained grounds to easy access to local parks and recreational activities.\n\nLocated in the heart of Greenville, OH, Hunters Oak provides the perfect setting for those who desire both tranquility and accessibility. You’ll be just minutes away from shopping, dining, and entertainment options, making it easy to enjoy everything the area has to offer.\n\nDon’t miss your chance to find your perfect home in our welcoming community! With a variety of floor plans available, we invite you to explore our offerings and see firsthand why Hunters Oak is the ideal place to live. **Find your new home today – browse our availability or schedule a tour to visit our community!** Your dream apartment awaits at Hunters Oak!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e6-b785-728e-b0dc-6bfbf3c11bd2.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with parked cars and a large tree.",
    "public_id": "019e46e6-b785-728e-b0dc-6bfbf3c11bd2",
    "storage_key": "property/6767906449167516/019e46e6-b785-728e-b0dc-6bfbf3c11bd2.webp",
    "width": 900,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "72",
  "property_year_built": "1998",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "No more than 2 animals per unit. Breed restrictions apply (e.g., no Pit Bulls, Rottweilers, German Shepherds, etc.). Pets must be spayed/neutered, over one year old, licensed, inoculated, and certified by a veterinarian.",
  "property_pet_policy_description": "CATS are allowed: weight limit 50 lbs each; additional deposit $200 per cat; additional monthly rent $25 per cat. DOGS are allowed: weight limit 50 lbs each; additional deposit $200 per dog; additional monthly rent $25 per dog. No more than 2 animals per unit. Breed restrictions apply (e.g., no Pit Bulls, Rottweilers, German Shepherds, etc.). Pets must be spayed/neutered, over one year old, licensed, inoculated, and certified by a veterinarian.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://huntersoak.loftliving.com/",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019ef542-1e54-7211-bdae-0e8151142055.webp",
  "property_primary_logo_media": {
    "alt_text": "Hunters Oak Apartments logo.",
    "public_id": "019ef542-1e54-7211-bdae-0e8151142055",
    "storage_key": "property/6767906449167516/019ef542-1e54-7211-bdae-0e8151142055.webp",
    "width": 2000,
    "height": 2000
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019ef542-1e54-7211-bdae-0e8151142055.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Hunters Oak Apartments logo.",
    "public_id": "019ef542-1e54-7211-bdae-0e8151142055",
    "storage_key": "property/6767906449167516/019ef542-1e54-7211-bdae-0e8151142055.webp",
    "width": 2000,
    "height": 2000
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019ef542-1ce0-740f-93fc-1e3ffc89b6ea.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Hunters Oak Apartments logo",
    "public_id": "019ef542-1ce0-740f-93fc-1e3ffc89b6ea",
    "storage_key": "property/6767906449167516/019ef542-1ce0-740f-93fc-1e3ffc89b6ea.webp",
    "width": 2000,
    "height": 2000
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#757B77",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "810 - 935",
  "property_sqft_min": "810",
  "property_sqft_max": "935",
  "property_price_range": "650 - 935",
  "property_price_min": "650",
  "property_price_max": "935",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/mkrentalswillardohio/",
  "property_instagram_url": null,
  "property_twitter_url": "https://twitter.com/pre_three",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJj9Y2K0brP4gRXp4JqrldKLU",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/twin-oaks-apartments-circleville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Hunters Oak",
  "property_home_romance_title": "Feel the Joy of Home in Our Vibrant Community",
  "property_home_amenities_blurb": "<p>Welcome to Hunters Oak, where modern living meets comfort in stunning Greenville, OH. Choose from spacious two and three-bedroom floor plans, all designed with you in mind. Enjoy pet-friendly amenities that cater to your lifestyle. Dive into a vibrant community that feels like home with our tax credit apartments in Greenville, OH. Let's make your next move unforgettable!</p>",
  "property_home_floorplans_blurb": "<p>At Hunters Oak in Greenville, OH, you’ll find spacious two- and three-bedroom apartments tailored for your lifestyle. Each floor plan features modern amenities and inviting spaces that create a true sense of home. Browse the best affordable apartments in Greenville, OH today to uncover the perfect layout for your new beginning!</p>",
  "property_home_gallery_blurb": "At Hunters Oak in Greenville, OH, your dream lifestyle awaits. With thoughtfully designed apartment floor plans and a welcoming, pet-friendly atmosphere, every day feels like a retreat. Imagine cozy evenings at home and outdoor adventures with your furry companions—picture yourself living here, where comfort meets community.",
  "property_home_neighborhood_blurb": "<p>Welcome to Hunters Oak in Greenville, OH, where comfort meets community! Just moments away from lush parks like Shawnee Prairie Preserve and vibrant local spots such as the Greenville Public Library, your new home offers not just stylish two and three-bedroom floor plans but also access to tax credit apartments in Greenville, OH, with enriching adventures right at your doorstep.</p>",
  "property_home_reviews_blurb": "Hunters Oak in Greenville, OH, reigns as a resident favorite, where comfort meets community spirit. One happy resident raves, “It feels like home the moment you step inside.” Embrace the welcoming atmosphere and find out why so many call it their sanctuary! Read our resident testimonials today!",
  "property_neighborhood_blurb": "Nestled in the heart of Greenville, Hunters Oak offers easy access to vibrant parks, enriching community centers, and the historic Garst Museum. Embrace an active lifestyle with nearby Turtle Creek Golf Course and Southside Splash Pad. Your ideal two or three-bedroom apartment awaits amid this lively neighborhood. Explore the local favorites today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Hunters Oak in Greenville, OH, your perfect home awaits! Choose from spacious two- and three-bedroom floor plans designed for comfort and style. Enjoy pet-friendly, affordable apartments with amenities that enhance your lifestyle. Elevate your living experience and feel at home in our vibrant community. Check out what we've crafted just for you!</p>",
  "property_applynow_blurb": "<p>At Hunters Oak in Greenville, OH, spacious two- and three-bedroom apartments await your arrival. Enjoy modern living with pet-friendly amenities that make your home cozy and inviting. Take the first step towards your dream lifestyle—apply now and lease online today for the perfect blend of comfort and community. Discover affordable housing in Greenville, OH at Hunters Oak.</p>",
  "property_contactus_blurb": "<p>At Hunters Oak in Greenville, OH, spacious two- and three-bedroom floor plans await. Each layout is designed for comfort and style, making it the perfect place to call home. Have questions? Our friendly leasing team is ready to assist you—reach out today to learn more about our affordable apartments in Greenville, OH!</p>",
  "property_faqs_blurb": "<p>At Hunters Oak in Greenville, OH, your ideal living space awaits with our thoughtfully designed two and three-bedroom floor plans. Elevate your lifestyle in a vibrant community—visit our FAQs page for insights and answers to help you find your perfect home among our pet-friendly, affordable apartments in Greenville, OH.</p>",
  "property_floorplans_blurb": "<p>At Hunters Oak in Greenville, OH, we offer thoughtfully designed two and three-bedroom floor plans that elevate your living experience. Each apartment blends comfort with modern style, ensuring you find the ideal space to call home. Browse our available affordable two-bedroom apartments in Greenville, OH and start envisioning your new lifestyle today!</p>",
  "property_gallery_blurb": "<p>At Hunters Oak in Greenville, OH, spacious two and three-bedroom apartments await your personal touch. With pet-friendly amenities and a blend of comfort and style, your ideal home is just a click away. Dive into our photo gallery and envision the vibrant lifestyle that awaits you at our pet-friendly, affordable apartments in Greenville, OH—picture yourself living here!</p>",
  "property_interactivemap_blurb": "At Hunters Oak in Greenville, OH, choose from spacious two and three-bedroom layouts designed for modern living. Enjoy pet-friendly amenities and a vibrant community atmosphere. Navigate our interactive community map to find your ideal apartment and unlock the door to your new home today!",
  "property_pets_blurb": "<p>At Hunters Oak in Greenville, OH, your four-legged friends are part of the family! With a welcoming pet policy that accommodates both cats and dogs under 50 lbs, your furry companions can enjoy life with you. Embrace a vibrant community with our pet-friendly, affordable apartments in Greenville, OH, where comfort meets companionship. Restrictions apply—learn more today!</p>",
  "property_referafriend_blurb": "At Hunters Oak in Greenville, OH, your ideal home awaits with spacious two- and three-bedroom floor plans designed for comfort and style. Great friends make great neighbors—invite your friends to experience vibrant living and community spirit. Refer a friend today and enhance your Hunters Oak experience together!",
  "property_residentaccess_blurb": "At Hunters Oak in Greenville, OH, our spacious two and three-bedroom floor plans are designed for comfort and style. Streamline your living experience—access your resident portal now to effortlessly pay rent, schedule maintenance, and enjoy a hassle-free lifestyle at our welcoming community!",
  "property_reviews_blurb": "<p>At Hunters Oak in Greenville, OH, our residents rave about their cozy homes, with one resident stating, “The friendly community atmosphere makes every day feel warm and inviting.” Immerse yourself in a lifestyle where comfort meets camaraderie at our affordable apartment community in Greenville, OH. See what our residents have to say about living at our community!</p>",
  "property_created_at": "1779305887281",
  "property_scheduletour_blurb": "<p>At Hunters Oak in Greenville, OH, our thoughtfully designed two- and three-bedroom apartments offer spacious living tailored to your lifestyle. Want to know more? Schedule a tour today and hear firsthand from our residents about the vibrant community and exceptional amenities that make Hunters Oak the perfect place to call home, with our tax-credit apartments in Greenville, OH!</p>",
  "property_thankyou_blurb": "<p>Thank you for reaching out to Hunters Oak in charming Greenville, OH! Exciting two-bedroom and spacious three-bedroom floor plans await you. Our team is eager to assist you in finding your perfect home at our affordable apartment community in Greenville, OH. Stay tuned as we connect with you shortly to bring your apartment search to life!</p>",
  "property_virtualtours_blurb": "<p>At Hunters Oak in Greenville, OH, our spacious two- and three-bedroom apartments blend comfort with style. Experience a virtual tour of our community, where modern living meets warm surroundings. Picture your new home and all the possibilities that await with our tax credit apartments in Greenville, OH. Dive in and envision your future today!</p>",
  "property_copyright": "2026 All Rights Reserved. Hunters Oak",
  "property_seo_title_home": "Affordable Apartments in Greenville, OH | Hunters Oak",
  "property_seo_description_home": "Explore affordable apartments in Greenville, OH at Hunters Oak. View 2 & 3 bedroom floor plans and learn about income qualifications and availability.",
  "property_seo_title_floorplans": "Floor Plans | Greenville, OH Apartments for Rent",
  "property_seo_description_floorplans": "Explore spacious 2 & 3-bedroom affordable apartments for rent near Downtown Greenville. Enjoy central air, dishwashers, balconies, and comfortable layouts.",
  "property_seo_title_amenities": "Apartment Amenities in Greenville, OH | Pet Friendly",
  "property_seo_description_amenities": "Enjoy affordable apartments in Greenville, OH, with balconies, central air, dishwashers, laundry, parking, and pet-friendly amenities.",
  "property_seo_title_gallery": "Tax Credit Apartments | Photos Hunters Oak Greenville",
  "property_seo_description_gallery": "Browse photos of Hunters Oak Apartments in OH, community amenities, balconies, pet-friendly spaces, and comfortable living in Darke County.",
  "property_seo_title_virtualtours": "Virtual Tour of Affordable Apartments in Greenville, OH",
  "property_seo_description_virtualtours": "Take a virtual tour of our Greenville apartment community with balconies, central air, dishwashers, and amenities near Edison State College, shopping & I-70.",
  "property_seo_title_interactivemap": "Interactive Apartment Leasing in Greenville, OH",
  "property_seo_description_interactivemap": "Start your leasing journey online. Explore the best apartment features, pet-friendly living, floor plans, and community amenities in Greenville.",
  "property_seo_title_neighborhood": "Affordable housing Near Shopping & Dining in Greenville",
  "property_seo_description_neighborhood": "Enjoy affordable apartments in Greenville, OH, near shopping, dining, healthcare, Greenville City Park, and convenient access to I-70.",
  "property_seo_title_contact": "Contact Hunters Oak Apartments in Greenville, OH",
  "property_seo_description_contact": "Contact Hunters Oak Apartments in OH for affordable 2- and 3-bedroom apartments, pet-friendly features, availability, and floor plans.",
  "property_seo_title_faqs": "FAQs | Affordable Apartments in Greenville, OH",
  "property_seo_description_faqs": "Get insights into Hunters Oak in Greenville, OH! Our FAQs cover everything from two- and three-bedroom layouts to pet-friendly perks. Check it out!",
  "property_seo_title_reviews": "Hunters Oak Apartments Reviews & Resident Feedback",
  "property_seo_description_reviews": "Read reviews of Hunters Oak Apartments and discover what residents appreciate about our pet-friendly community, amenities, location, and apartment homes.",
  "property_seo_title_applynow": "Apply to Affordable Apartment Community in Greenville, OH",
  "property_seo_description_applynow": "Apply online for affordable housing in Greenville near Downtown Greenville. Enjoy pet-friendly living, parking, laundry facilities, and modern conveniences.",
  "property_seo_title_residentaccess": "Resident Portal | Hunters Oak Apartments",
  "property_seo_description_residentaccess": "Access online resident services, maintenance requests, payments, and community information at Hunters Oak Apartments and rent in Greenville, OH.",
  "property_seo_title_referafriend": "Refer A Friend | Hunters Oak",
  "property_seo_description_referafriend": "Refer a friend to Hunters Oak in Greenville, OH! Great friends make the best neighbors—share the love and enjoy community perks together!",
  "property_seo_title_scheduletour": "Schedule a Tour at Hunters Oak Apartments for rent in OH",
  "property_seo_description_scheduletour": "Schedule your tour of Hunters Oak, tax-credit apartments, and explore spacious apartment homes, pet-friendly amenities, parking, and nearby attractions.",
  "property_seo_title_privacy": "Privacy Policy | Hunters Oak Apartments",
  "property_seo_description_privacy": "Read the privacy policy for Hunters Oak Apartments and learn how information is collected, used, and protected online.",
  "property_seo_title_accessibility": "Accessibility Statement | Hunters Oak Affordable Apartments",
  "property_seo_description_accessibility": "Review accessibility information for Hunters Oak Apartments and explore resources designed to enhance your website experience.",
  "property_seo_title_sitemap": "Sitemap | Hunters Oak Apartments Greenville, OH",
  "property_seo_description_sitemap": "View the Hunters Oak Apartments sitemap to quickly navigate floor plans, amenities, photos, leasing resources, and community information.",
  "property_seo_title_thankyou": "Thank You for Contacting Hunters Oak Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in Hunters Oak Apartments. Our team will be in touch soon regarding availability, tours, and apartment living.",
  "property_seo_title_pets": "Pet Friendly Affordable Apartments in Greenville, OH",
  "property_seo_description_pets": "Learn about our pet policy, community guidelines, and pet-friendly apartment living near parks, shopping, and local services. Live close to Greenville, OH.",
  "property_updated_at": "1790198702524",
  "amenities": [
    {
      "id": "custom_abebbc48-6490-479a-a448-f5ff0862b958",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2e5f3f4-3a20-4081-8dc3-30261585f243",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_315b2321-3361-474a-ba99-fb70c6b97f9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9bf84d3f-7391-48a7-86d5-4aa37d39d76c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Dry Cleaning Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_82bdc601-c2e3-48a2-955f-cdd22993487e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d034ab69-a815-4de3-b338-fb47d2d37cbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33577ad1-ac52-4ccb-8dfc-81f57bd9a79d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb8c6494-9b72-47bc-a447-6f5fde430be0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Close to Dining, Shopping, & Fitness Gyms",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d004bf6-b597-484c-b08e-5e5b7942dca1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Generous Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bbc59ed8-6bd7-415c-831e-520f134ef139",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Interior Intercom System",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_28b3465c-ee31-4ba4-96e4-9df44f72a61f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eb8d9046-b4e0-4b72-8285-de9cabfdedac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Stove",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e6dcff7-d39b-4c53-bb54-9302db022b04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ea08385-f69a-4c72-91dc-089d65cbe2d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0fa4f56d-45a1-4f5b-bc28-28deaf098c77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Intercom",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9f4b5e1-73ea-4b0a-97d9-9d7c55108390",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_25cebe2a-8ca9-4d20-b6f3-dd1baa8d0c5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8446ccb1-1392-44b4-b0e0-9569e009a125",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53812d41-59ff-4016-809c-a21571568ab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_701229e4-9add-486b-a1dc-2271df7fab8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_405d85e4-c6c7-4a33-befa-a3b74f744f01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_adce52f4-5376-4ef6-863c-552d3e9e6e7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3838e87a-fc0c-4671-81fa-4f186798272b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-799e-7079-894f-64d778eda6a3.webp",
      "image_media": {
        "alt_text": "Welcome Center building entrance with American flag at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-799e-7079-894f-64d778eda6a3",
        "storage_key": "property/6767906449167516/019e8f34-799e-7079-894f-64d778eda6a3.webp",
        "width": 3072,
        "height": 2291
      },
      "title": "Community",
      "description": "The Welcome Center building entrance at this multifamily property features an American flag and a sign indicating 'Welcome Center'.",
      "link": "",
      "alt_text": "Welcome Center building entrance with American flag at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2022f0e6-250e-447e-bbf8-3b56f3a8710f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019f054c-8231-739e-9bb1-de6ac68c57c2.webp",
      "image_media": {
        "alt_text": "Couple looking at a smartphone together while working or planning at Hunters Oak in Greenville, OH.",
        "public_id": "019f054c-8231-739e-9bb1-de6ac68c57c2",
        "storage_key": "property/6767906449167516/019f054c-8231-739e-9bb1-de6ac68c57c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A couple is seated at a table, engaged with a smartphone. The woman is on the left, and the man is on the right. They appear to be collaborating on a task, possibly planning or working together.",
      "link": "",
      "alt_text": "Couple looking at a smartphone together while working or planning at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab3445f9-f7c3-4a88-9188-4adbc95cf30f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019f054c-6aa0-767a-a4b6-4df505f3bc99.webp",
      "image_media": {
        "alt_text": "A father lifts his laughing son in the air at Hunters Oak in Greenville, OH.",
        "public_id": "019f054c-6aa0-767a-a4b6-4df505f3bc99",
        "storage_key": "property/6767906449167516/019f054c-6aa0-767a-a4b6-4df505f3bc99.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "Create lasting memories with your loved ones in your new home. Enjoy quality time and joyful moments together.",
      "link": "",
      "alt_text": "A father lifts his laughing son in the air at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4470545a-0043-4145-a208-89e8eae6901b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-7cc7-706d-a58f-0b82cff8292a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with brick and siding, balconies, and parking lot at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-7cc7-706d-a58f-0b82cff8292a",
        "storage_key": "property/6767906449167516/019e8f34-7cc7-706d-a58f-0b82cff8292a.webp",
        "width": 3072,
        "height": 2131
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a mix of brick and siding, private balconies, and convenient parking, set against a backdrop of green lawns and a blue sky.",
      "link": "",
      "alt_text": "Exterior view of apartment building with brick and siding, balconies, and parking lot at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_af3b7192-cb4b-4ae3-ba94-352c427c9a0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019f054c-915a-753c-9cfe-956fe48fb2da.webp",
      "image_media": {
        "alt_text": "Man holding a mug, smiling, with a living room in the background at Hunters Oak in Greenville, OH.",
        "public_id": "019f054c-915a-753c-9cfe-956fe48fb2da",
        "storage_key": "property/6767906449167516/019f054c-915a-753c-9cfe-956fe48fb2da.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy your morning coffee in your comfortable living room. This image captures a relaxed lifestyle within the apartment.",
      "link": "",
      "alt_text": "Man holding a mug, smiling, with a living room in the background at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_def8ac3e-6ac5-4456-a673-f21a5e37e062",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-71da-723a-8ed9-1970baf8e5a7.webp",
      "image_media": {
        "alt_text": "Apartment complex with a playground and bicycles parked outside at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-71da-723a-8ed9-1970baf8e5a7",
        "storage_key": "property/6767906449167516/019e8f34-71da-723a-8ed9-1970baf8e5a7.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Outdoor view of the community amenities, including a playground and bicycle racks, with apartment buildings in the background.",
      "link": "",
      "alt_text": "Apartment complex with a playground and bicycles parked outside at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8a6b1531-fb12-4d26-a767-4feb3ceb2f8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-7364-70cb-9ad0-1e1b6c767520.webp",
      "image_media": {
        "alt_text": "Interior view showing multiple doors and carpeted floors at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-7364-70cb-9ad0-1e1b6c767520",
        "storage_key": "property/6767906449167516/019e8f34-7364-70cb-9ad0-1e1b6c767520.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Discover the details of your new home with this interior view, showcasing multiple doorways and comfortable carpeted flooring.",
      "link": "",
      "alt_text": "Interior view showing multiple doors and carpeted floors at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c8dae851-d606-468d-9f41-015b67d55cef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-6f54-7700-b8d0-0e8efd733d21.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and vanity at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-6f54-7700-b8d0-0e8efd733d21",
        "storage_key": "property/6767906449167516/019e8f34-6f54-7700-b8d0-0e8efd733d21.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet and a private vanity area with a sink and mirror.",
      "link": "",
      "alt_text": "Bedroom with closet and vanity at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1150d4c3-5971-4026-9b2a-6ba785162c9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019f054c-76db-734c-baef-888a3dc79408.webp",
      "image_media": {
        "alt_text": "Two young women laughing while looking at a smartphone together at Hunters Oak in Greenville, OH.",
        "public_id": "019f054c-76db-734c-baef-888a3dc79408",
        "storage_key": "property/6767906449167516/019f054c-76db-734c-baef-888a3dc79408.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "Experience a vibrant community where connections are made. This image captures a moment of shared joy and connection, reflecting the lifestyle at our property.",
      "link": "",
      "alt_text": "Two young women laughing while looking at a smartphone together at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_16f4a0d6-3147-4986-aa9e-ca7c77b8a906",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-593b-771d-acbe-ec2987fa078b.webp",
      "image_media": {
        "alt_text": "Apartment building with a playground and parking lot.",
        "public_id": "019e8f34-593b-771d-acbe-ec2987fa078b",
        "storage_key": "property/6767906449167516/019e8f34-593b-771d-acbe-ec2987fa078b.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Community",
      "description": "Exterior view of an apartment building featuring a children's playground and nearby parking.",
      "link": "",
      "alt_text": "Apartment building with a playground and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1fe44240-c254-4649-883f-082b7a07c0c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-5bdf-73f8-8478-f8f8107caca0.webp",
      "image_media": {
        "alt_text": "Empty room with carpet and vertical blinds on sliding glass door at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-5bdf-73f8-8478-f8f8107caca0",
        "storage_key": "property/6767906449167516/019e8f34-5bdf-73f8-8478-f8f8107caca0.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A spacious, empty room featuring neutral-toned carpet and a large sliding glass door with vertical blinds, offering natural light.",
      "link": "",
      "alt_text": "Empty room with carpet and vertical blinds on sliding glass door at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d883080-a2bd-461a-81a9-48a46eb0767a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019f054c-65f6-7747-bfa6-8bad6fc3b387.webp",
      "image_media": {
        "alt_text": "Couple enjoying a meal together at a table at Hunters Oak in Greenville, OH.",
        "public_id": "019f054c-65f6-7747-bfa6-8bad6fc3b387",
        "storage_key": "property/6767906449167516/019f054c-65f6-7747-bfa6-8bad6fc3b387.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A couple shares a meal and smiles at each other in a cozy kitchen setting, highlighting the comfort and enjoyment of home dining.",
      "link": "",
      "alt_text": "Couple enjoying a meal together at a table at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96a643b5-b0e0-4f6f-818e-f5a6269f95c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-59b6-70af-be8d-dec85c146d42.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment with a pass-through window to the kitchen and a dining area with a ceiling fan at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-59b6-70af-be8d-dec85c146d42",
        "storage_key": "property/6767906449167516/019e8f34-59b6-70af-be8d-dec85c146d42.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious interior of an apartment showcasing a living area, dining space, and a view into the kitchen. Features a ceiling fan and ample natural light.",
      "link": "",
      "alt_text": "Interior view of an apartment with a pass-through window to the kitchen and a dining area with a ceiling fan at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b53aef9f-1732-4138-a2a1-0a6c904eedef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-5950-732f-bf55-eaf2338dd975.webp",
      "image_media": {
        "alt_text": "Empty room with a window and beige carpet at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-5950-732f-bf55-eaf2338dd975",
        "storage_key": "property/6767906449167516/019e8f34-5950-732f-bf55-eaf2338dd975.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "This is an empty room with a large window, offering a blank canvas for your personal style.",
      "link": "",
      "alt_text": "Empty room with a window and beige carpet at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_98d89fe1-de8e-4ea1-9446-d84d61acb29c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-360a-7061-bd8d-8a9cd4f5bb14.webp",
      "image_media": {
        "alt_text": "Playground with swings and slides at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-360a-7061-bd8d-8a9cd4f5bb14",
        "storage_key": "property/6767906449167516/019e8f34-360a-7061-bd8d-8a9cd4f5bb14.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring swings and slides for endless entertainment.",
      "link": "",
      "alt_text": "Playground with swings and slides at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a873a250-2b1b-41c6-8c87-6e6f4c3811d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019f054c-5b0e-73df-b3ae-812ba01daa62.webp",
      "image_media": {
        "alt_text": "Man bonding with his cat, looking lovingly at the pet at Hunters Oak in Greenville, OH.",
        "public_id": "019f054c-5b0e-73df-b3ae-812ba01daa62",
        "storage_key": "property/6767906449167516/019f054c-5b0e-73df-b3ae-812ba01daa62.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoying precious moments with your furry friend is part of the lifestyle at our pet-friendly community.",
      "link": "",
      "alt_text": "Man bonding with his cat, looking lovingly at the pet at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0d0cbe5-b7c1-49e8-b82b-565c4f76022f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-39f7-7335-b9a8-416f74fc4fac.webp",
      "image_media": {
        "alt_text": "Exterior of a brick and vinyl apartment building with balconies and windows at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-39f7-7335-b9a8-416f74fc4fac",
        "storage_key": "property/6767906449167516/019e8f34-39f7-7335-b9a8-416f74fc4fac.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "View of the exterior of an apartment building, showcasing its brick facade, vinyl siding, multiple balconies, and windows.",
      "link": "",
      "alt_text": "Exterior of a brick and vinyl apartment building with balconies and windows at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9960334a-8601-448b-aff0-ff93bafe90ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-374e-7601-8351-194dbf9e313e.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a playground and parking lot at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-374e-7601-8351-194dbf9e313e",
        "storage_key": "property/6767906449167516/019e8f34-374e-7601-8351-194dbf9e313e.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings, featuring a children's playground and a parking area with cars.",
      "link": "",
      "alt_text": "Apartment buildings with a playground and parking lot at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_25544922-3dcf-4ffa-87e6-b8acea7036bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-360b-74f6-92d8-c00f5b0731e7.webp",
      "image_media": {
        "alt_text": "Parking lot and apartment building exterior at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-360b-74f6-92d8-c00f5b0731e7",
        "storage_key": "property/6767906449167516/019e8f34-360b-74f6-92d8-c00f5b0731e7.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Exterior view of the apartment building and its surrounding parking lot on a sunny day.",
      "link": "",
      "alt_text": "Parking lot and apartment building exterior at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dadf987c-3fbb-4685-a1d7-8e8bf5190151",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e8f34-42a7-75db-b383-f961a9e71664.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment bedroom with a closet and a door at Hunters Oak in Greenville, OH.",
        "public_id": "019e8f34-42a7-75db-b383-f961a9e71664",
        "storage_key": "property/6767906449167516/019e8f34-42a7-75db-b383-f961a9e71664.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a large closet and a door leading to another part of the apartment.",
      "link": "",
      "alt_text": "Interior view of an apartment bedroom with a closet and a door at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_33169a85-19f7-4dbb-93c5-bc5b73c44f4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019f054c-8e43-7699-bb9d-778fbd6f2fb0.webp",
      "image_media": {
        "alt_text": "A young woman relaxes on a blue sofa, smiling while browsing on her smartphone in a bright living room at Hunters Oak in Greenville, OH.",
        "public_id": "019f054c-8e43-7699-bb9d-778fbd6f2fb0",
        "storage_key": "property/6767906449167516/019f054c-8e43-7699-bb9d-778fbd6f2fb0.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "Our apartment homes are designed for your comfort and convenience. Enjoy quiet moments on the sofa, stay connected with loved ones, or simply unwind after a long day in your cozy living space.",
      "link": "",
      "alt_text": "A young woman relaxes on a blue sofa, smiling while browsing on her smartphone in a bright living room at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f195623f-c4ed-4047-9ea7-89630ae6df8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019f054c-9361-74ec-82fc-fbcd362bbaf8.webp",
      "image_media": {
        "alt_text": "People walking a dog in a park at Hunters Oak in Greenville, OH.",
        "public_id": "019f054c-9361-74ec-82fc-fbcd362bbaf8",
        "storage_key": "property/6767906449167516/019f054c-9361-74ec-82fc-fbcd362bbaf8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a walk in the park with your furry friend. Our community is pet-friendly and offers beautiful outdoor spaces for you and your dog to explore.",
      "link": "",
      "alt_text": "People walking a dog in a park at Hunters Oak in Greenville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f33be864-4534-46bc-a05e-d0bb30bc96f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Maid-Rite Sandwich Shoppe",
      "poi_type": "Restaurants",
      "poi_address": "125 N Broadway St, Greenville, OH 45331, USA",
      "poi_short_description": "Veteran, dinerlike eatery serving signature ground-beef sandwiches, plus sides & shakes.",
      "poi_long_description": "People say this sandwich shop serves delicious loose meat burgers, cheese rites, and shakes. They highlight the reasonable prices and nostalgic, old-school vibe. They also like the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-5210-73a0-855a-5e11bdae2df7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-5210-73a0-855a-5e11bdae2df7",
        "storage_key": "property/6767906449167516/019e46e5-5210-73a0-855a-5e11bdae2df7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.maidrite-greenville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17136479326081969955&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maid-rite-sandwich-shoppe",
      "poi_latitude": "40.1052",
      "poi_longitude": "-84.636168",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-548-9340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-992d-701c-973b-e4f09d2e8f2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-992d-701c-973b-e4f09d2e8f2e",
        "storage_key": "property/6767906449167516/019e46e5-992d-701c-973b-e4f09d2e8f2e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyY9j3WLrP4gRI-_wcycB0e0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_f3ebfe4c-fe41-47d7-a0cb-0839b955f01b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Asian Buffet",
      "poi_type": "Restaurants",
      "poi_address": "521 Wagner Ave, Greenville, OH 45331, USA",
      "poi_short_description": "All-you-can-eat eatery with a salad bar, sushi, a buffet of raw ingredients, and a teppanyaki grill.",
      "poi_long_description": "Guests consistently praise this Asian buffet for its wide selection of fresh food, including good hibachi and sushi, alongside many classic options. The clean environment, reasonable prices, and friendly staff further enhance the dining experience.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-59ff-7711-b65f-a1a19972550d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-59ff-7711-b65f-a1a19972550d",
        "storage_key": "property/6767906449167516/019e46e5-59ff-7711-b65f-a1a19972550d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://asianbuffet1.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15948184284552682240&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "asian-buffet",
      "poi_latitude": "40.115919",
      "poi_longitude": "-84.620696",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-316-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-992d-701c-973b-e4f09d2e8f2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-992d-701c-973b-e4f09d2e8f2e",
        "storage_key": "property/6767906449167516/019e46e5-992d-701c-973b-e4f09d2e8f2e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuVfAhEPrP4gRANs6FRxVU90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_c40644df-baba-4a08-88a1-607607c1bf7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Tolly's Gastropub",
      "poi_type": "Restaurants",
      "poi_address": "644 Wagner Ave, Greenville, OH 45331, USA",
      "poi_short_description": "Relaxed gastropub providing classic comfort food, small plates, and vegetarian items, plus happy-hour specials.",
      "poi_long_description": "Customers consistently praise this restaurant for its delicious and plentiful food, noting the huge portions and the extensive menu that provides a wide variety of options. They also appreciate the friendly service and find the prices to be reasonable.\n\nSome reviews mention the service can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-5924-73bb-8aab-94856ef253b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-5924-73bb-8aab-94856ef253b9",
        "storage_key": "property/6767906449167516/019e46e5-5924-73bb-8aab-94856ef253b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6191457669364628338&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tollys-gastropub",
      "poi_latitude": "40.1181244",
      "poi_longitude": "-84.62297640000001",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 937-459-5225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98cc-774a-bb2d-feec85051aa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98cc-774a-bb2d-feec85051aa6",
        "storage_key": "property/6767906449167516/019e46e5-98cc-774a-bb2d-feec85051aa6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wW_SEHrP4gRcrtYUPJ57FU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gastropub"
    },
    {
      "id": "custom_e7ba7cc2-a6a7-4af8-ab18-ca2645835f8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "La Carreta 3 Mexican Grill & Cantina",
      "poi_type": "Restaurants",
      "poi_address": "925 Sweitzer St, Greenville, OH 45331, USA",
      "poi_short_description": "Chicken fajitas and other familiar Mexican eats are on the menu at this relaxed spot.",
      "poi_long_description": "Diners say this Mexican restaurant serves up delicious birria tacos, steak fajita tacos, and a variety of salsas. They also highlight the quick and friendly service, and the clean and inviting atmosphere with plenty of outdoor seating.\n\nSome reviews mention the food can be salty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-5a5c-770a-87c2-de5e7763f66e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-5a5c-770a-87c2-de5e7763f66e",
        "storage_key": "property/6767906449167516/019e46e5-5a5c-770a-87c2-de5e7763f66e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://lacarretagreenville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10080524653254522776&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-carreta-3-mexican-grill--cantina",
      "poi_latitude": "40.0871138",
      "poi_longitude": "-84.6346276",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 937-459-4708",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-992d-701c-973b-e4f09d2e8f2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-992d-701c-973b-e4f09d2e8f2e",
        "storage_key": "property/6767906449167516/019e46e5-992d-701c-973b-e4f09d2e8f2e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzdmxXVztP4gRmLfNYsM35Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c6f316ea-abb8-4be0-8e48-2772feb57544",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "JT's Brew & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1475 Wagner Ave, Greenville, OH 45331, USA",
      "poi_short_description": "Casual, family-friendly eatery, dishing up burgers and steak to fried chicken and pizza, plus beer, wine and cocktails.",
      "poi_long_description": "Diners like this restaurant's delicious burgers, chicken tenders, and fries, with many highlighting the quality of the food and the variety of lunch specials. They also mention the friendly staff, pleasant atmosphere, and convenient drive-thru option.\n\nSome reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-5019-77e6-86f4-5d7a38ae49de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-5019-77e6-86f4-5d7a38ae49de",
        "storage_key": "property/6767906449167516/019e46e5-5019-77e6-86f4-5d7a38ae49de.webp",
        "width": 838,
        "height": 625
      },
      "poi_business_url": "http://www.jtbrewandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14041655298039352691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jts-brew--grill",
      "poi_latitude": "40.125282",
      "poi_longitude": "-84.619839",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 937-548-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98cc-774a-bb2d-feec85051aa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98cc-774a-bb2d-feec85051aa6",
        "storage_key": "property/6767906449167516/019e46e5-98cc-774a-bb2d-feec85051aa6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-zU4jjrP4gRcw0eAhn73cI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_68f4fc3a-f6db-408b-b5d6-0a63ccf9be84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1550 Wagner Ave, Greenville, OH 45331, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-4f7c-73fd-912d-4e3a2510dca6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-4f7c-73fd-912d-4e3a2510dca6",
        "storage_key": "property/6767906449167516/019e46e5-4f7c-73fd-912d-4e3a2510dca6.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OH-Greenville/2524?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2524-_-na-_-0-_-0&y_source=1_MTE4NDQ1OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11374876192689139786&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "40.1292524",
      "poi_longitude": "-84.62070070000001",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-547-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98f4-705d-84ce-c258581492e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98f4-705d-84ce-c258581492e3",
        "storage_key": "property/6767906449167516/019e46e5-98f4-705d-84ce-c258581492e3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl9vaPjnrP4gRSrBIbaGt250",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_45af5197-b156-4a48-9a37-68eadb76a0a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "200 Lease Ave, Greenville, OH 45331, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this store offers a good selection of seafood and meat products, and is generally clean and well-stocked. Visitors also highlight the good quality and value of items, and appreciate the quick in-store shopping experience.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-4fc1-70cd-81b2-7dcd6f900fbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-4fc1-70cd-81b2-7dcd6f900fbe",
        "storage_key": "property/6767906449167516/019e46e5-4fc1-70cd-81b2-7dcd6f900fbe.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/greenville/greenville/014/00833?cid=loc_01400833_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6149458976136141825&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "40.1269122",
      "poi_longitude": "-84.6226671",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-548-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98eb-701e-b49d-a9d7f65e8004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98eb-701e-b49d-a9d7f65e8004",
        "storage_key": "property/6767906449167516/019e46e5-98eb-701e-b49d-a9d7f65e8004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8qWtj7rP4gRAZxuiVtEV1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_55d9b1bf-e884-4c71-a1ca-7a17ab34f049",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "415 Wagner Ave, Greenville, OH 45331, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this grocery store offers a great selection of products, including fresh fruit, vegetables, and quality meats. They also highlight the unbeatable and reasonable prices, allowing customers to get more for their money. Others mention the clean store, helpful staff, and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-58c8-749a-86a8-06aa1de50127.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-58c8-749a-86a8-06aa1de50127",
        "storage_key": "property/6767906449167516/019e46e5-58c8-749a-86a8-06aa1de50127.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://info.aldi.us/stores/l/oh/greenville/415-wagner-ave/f540",
      "poi_directions_map_url": "https://maps.google.com/?cid=12070463227297688214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "40.11409099999999",
      "poi_longitude": "-84.622039",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98eb-701e-b49d-a9d7f65e8004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98eb-701e-b49d-a9d7f65e8004",
        "storage_key": "property/6767906449167516/019e46e5-98eb-701e-b49d-a9d7f65e8004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT_O5YEPrP4gRlmp-aVrmgqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_59e39bb0-d004-498f-b6ae-7935a391f015",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Flour Barrel",
      "poi_type": "Shopping & Retail",
      "poi_address": "8138 US-36, Bradford, OH 45308, USA",
      "poi_short_description": "Charming store fronting a deli counter offering baked goods and chocolates, plus spices.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-5863-700a-8d27-e8489c1b8a72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-5863-700a-8d27-e8489c1b8a72",
        "storage_key": "property/6767906449167516/019e46e5-5863-700a-8d27-e8489c1b8a72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15196321113735716432&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flour-barrel",
      "poi_latitude": "40.1114814",
      "poi_longitude": "-84.5031394",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 937-447-4925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98eb-701e-b49d-a9d7f65e8004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98eb-701e-b49d-a9d7f65e8004",
        "storage_key": "property/6767906449167516/019e46e5-98eb-701e-b49d-a9d7f65e8004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8lmgf6XP4gRUF78FIot5NI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_29abbfbc-968f-4342-8503-d503ff0916e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Eikenberry's IGA Greenville",
      "poi_type": "Shopping & Retail",
      "poi_address": "1120 Sweitzer St, Greenville, OH 45331, USA",
      "poi_short_description": "Longtime bakery & grocery offering fried chicken, a deli counter and friendly staff.",
      "poi_long_description": "People say this grocery store offers a great selection of fresh meats, delicious deli items, and amazing donuts. They also highlight the friendly and helpful staff, noting the clean and well-run environment. Guests mention the convenient shopping experience and good value on various deals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-5999-7052-beb0-7f7a957be93b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-5999-7052-beb0-7f7a957be93b",
        "storage_key": "property/6767906449167516/019e46e5-5999-7052-beb0-7f7a957be93b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://eikenberryfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12897643288334174610&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eikenberrys-iga-greenville",
      "poi_latitude": "40.0839573",
      "poi_longitude": "-84.6350562",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 937-548-9214",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98eb-701e-b49d-a9d7f65e8004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98eb-701e-b49d-a9d7f65e8004",
        "storage_key": "property/6767906449167516/019e46e5-98eb-701e-b49d-a9d7f65e8004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKwp9vZLsP4gRkgnccDyi_bI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_25cbf318-6647-4d13-ac25-cfabe6ac3c2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Greenville Public Library",
      "poi_type": "Education",
      "poi_address": "520 Sycamore St, Greenville, OH 45331, USA",
      "poi_short_description": "Family-friendly, serene spot for free wi-fi and computer access, as well as books.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-71b1-70bb-9657-ff851bfbe0fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-71b1-70bb-9657-ff851bfbe0fd",
        "storage_key": "property/6767906449167516/019e46e5-71b1-70bb-9657-ff851bfbe0fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.greenville-publiclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=135706254563915455&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "greenville-public-library",
      "poi_latitude": "40.0991088",
      "poi_longitude": "-84.6326584",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-548-3915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98d2-73be-b96a-5463a356b429.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98d2-73be-b96a-5463a356b429",
        "storage_key": "property/6767906449167516/019e46e5-98d2-73be-b96a-5463a356b429.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkxWzGJzsP4gRv7YUmR4g4gE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_032c0ec0-0d9a-4f31-9a7e-650e25e58ee6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Anthony Wayne and Care-A-Lot Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "4932 Childrens Home-Bradford Rd, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://awecc.darkeesc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=306092450801530906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anthony-wayne-and-care-a-lot-early-childhood-center",
      "poi_latitude": "40.1363729",
      "poi_longitude": "-84.62166909999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-548-8323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98d2-73be-b96a-5463a356b429.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98d2-73be-b96a-5463a356b429",
        "storage_key": "property/6767906449167516/019e46e5-98d2-73be-b96a-5463a356b429.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHfwb953sP4gRGjh0VnZ1PwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_50388f50-ef35-4fda-bdf5-2a08971e3ebf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Edison State Community College at Greenville",
      "poi_type": "Education",
      "poi_address": "601 Wagner Ave, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-65b0-7289-933c-2f1751d8599d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-65b0-7289-933c-2f1751d8599d",
        "storage_key": "property/6767906449167516/019e46e5-65b0-7289-933c-2f1751d8599d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.edisonohio.edu/Greenville/?utm_source=Google&utm_medium=Organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=9166528905667670220&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edison-state-community-college-at-greenville",
      "poi_latitude": "40.1167121",
      "poi_longitude": "-84.6206771",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-548-5546",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98d2-73be-b96a-5463a356b429.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98d2-73be-b96a-5463a356b429",
        "storage_key": "property/6767906449167516/019e46e5-98d2-73be-b96a-5463a356b429.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi02L8UPrP4gRzPCrLXkNNn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_eff95e64-4f6b-423f-bbe2-6db00ffec6c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "CORS Head Start - Sweitzer St",
      "poi_type": "Education",
      "poi_address": "1170 Sweitzer St, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.corsp.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=468320725226958032&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cors-head-start---sweitzer-st",
      "poi_latitude": "40.0833261",
      "poi_longitude": "-84.6349714",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 937-547-9899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98d2-73be-b96a-5463a356b429.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98d2-73be-b96a-5463a356b429",
        "storage_key": "property/6767906449167516/019e46e5-98d2-73be-b96a-5463a356b429.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOWRPz5LsP4gR0Cwb5DfPfwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_4fd7297e-f817-4551-96f0-0d84a96615bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Bear's Mill",
      "poi_type": "Entertainment",
      "poi_address": "6450 Arcanum Bears Mill Rd, Greenville, OH 45331, USA",
      "poi_short_description": "Built in 1849, this operating water-powered mill sells stone-ground flours and grains, and offers a gift shop.",
      "poi_long_description": "Visitors say this historic mill offers engaging tours of its multiple floors, showcasing old artifacts and equipment, and features a gift shop with unique items like homemade bread, flours, and coffee. They also highlight the friendly and helpful staff, as well as the beautiful grounds with walking trails and a covered bridge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-702d-737e-905e-71cb421ba998.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-702d-737e-905e-71cb421ba998",
        "storage_key": "property/6767906449167516/019e46e5-702d-737e-905e-71cb421ba998.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bearsmill.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18128380616343838404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bears-mill",
      "poi_latitude": "40.1068097",
      "poi_longitude": "-84.5420772",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 937-548-5112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwd7cIw2UP4gRxF5ATh_ylPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_fdcb08b3-8778-4c85-98f7-bb1922186469",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Garst Museum",
      "poi_type": "Entertainment",
      "poi_address": "205 N Broadway St, Greenville, OH 45331, USA",
      "poi_short_description": "Museum dedicated to local history, including an exhibit on sharpshooter Annie Oakley.",
      "poi_long_description": "Visitors say this museum offers a surprisingly wide range of well-curated exhibits, including authentic American Indian relics and detailed local history. They also highlight the extensive collection of artifacts and the immaculate, well-kept facility. Guests mention the staff and volunteers are wonderful and enhance the experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-7476-7798-ae91-8c1c1a247303.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-7476-7798-ae91-8c1c1a247303",
        "storage_key": "property/6767906449167516/019e46e5-7476-7798-ae91-8c1c1a247303.webp",
        "width": 1199,
        "height": 1280
      },
      "poi_business_url": "http://www.garstmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12081344909883523909&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "garst-museum",
      "poi_latitude": "40.107012",
      "poi_longitude": "-84.636607",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-548-5250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c8-7758-8755-38118aa484ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c8-7758-8755-38118aa484ea",
        "storage_key": "property/6767906449167516/019e46e5-98c8-7758-8755-38118aa484ea.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJN537QGPrP4gRRcOUki-Pqac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_168eaf8c-7e9e-4efc-ac8b-6ae0737e35c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Southside Splash Pad",
      "poi_type": "Entertainment",
      "poi_address": "Greenville, OH 45331, USA",
      "poi_short_description": "Small park with a splash pad and playground, popular with kids of all ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-7801-711b-937f-bc76bd3df80a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-7801-711b-937f-bc76bd3df80a",
        "storage_key": "property/6767906449167516/019e46e5-7801-711b-937f-bc76bd3df80a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11955649238242507040&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southside-splash-pad",
      "poi_latitude": "40.0902442",
      "poi_longitude": "-84.6284408",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk2kCzFHtP4gRIDmdcKP_6qU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_7d7d627d-489b-4ff9-9d91-2ec3b52ccabd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Fort Greenville",
      "poi_type": "Entertainment",
      "poi_address": "Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-741e-717d-8baa-a2a4bd753d91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-741e-717d-8baa-a2a4bd753d91",
        "storage_key": "property/6767906449167516/019e46e5-741e-717d-8baa-a2a4bd753d91.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityofgreenville.org/2160/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=10979865242938001169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-greenville",
      "poi_latitude": "40.1052388",
      "poi_longitude": "-84.6324279",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7w1jKWLrP4gREUf6vkNRYJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_95f40d03-fd44-4cc4-8274-2a2cd865c9d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Annie Oakley Park",
      "poi_type": "Entertainment",
      "poi_address": "Martin St, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-71c8-7319-9b99-1d44bec87a63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-71c8-7319-9b99-1d44bec87a63",
        "storage_key": "property/6767906449167516/019e46e5-71c8-7319-9b99-1d44bec87a63.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6319099465624328783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "annie-oakley-park",
      "poi_latitude": "40.09920109999999",
      "poi_longitude": "-84.62977",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUVV4J7sP4gRTxrm5HvzsVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_f88f58b0-db5f-478e-a2aa-f7d7e3d06dbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "1520 Wagner Ave, Greenville, OH 45331, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-6de3-724f-af78-7fcbe7ef8f98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-6de3-724f-af78-7fcbe7ef8f98",
        "storage_key": "property/6767906449167516/019e46e5-6de3-724f-af78-7fcbe7ef8f98.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/oh/greenville/1520-wagner-ave?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=877701989382994092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "40.1273939",
      "poi_longitude": "-84.6202907",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-547-0010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCzbNZznrP4gRrLjTH085Lgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_837d75d0-8cfa-4300-9c01-0d5a33506776",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Snap Fitness Greenville",
      "poi_type": "Health and Wellness",
      "poi_address": "1370 A/B Kitchen Aid Way, Greenville, OH 45331, USA",
      "poi_short_description": "Welcoming gym offering training equipment, workouts and various classes (including kickboxing).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-715f-776b-a48b-a4e7f1eaf786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-715f-776b-a48b-a4e7f1eaf786",
        "storage_key": "property/6767906449167516/019e46e5-715f-776b-a48b-a4e7f1eaf786.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.snapfitness.com/us/gyms/greenville-oh/?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14162280786235266988&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snap-fitness-greenville",
      "poi_latitude": "40.1236547",
      "poi_longitude": "-84.61387739999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 937-547-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9S9vS0frP4gRrJfkEFeHisQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c06be017-95cd-4fef-aeb9-ab8e8c31ca9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Hartzell Veterinary Service: Charles W. Hartzell, DVM and Sue Ann Hartzell, DVM",
      "poi_type": "Health and Wellness",
      "poi_address": "5646 Horatio-Harris Creek Rd, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-798a-739d-a17d-922951949384.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-798a-739d-a17d-922951949384",
        "storage_key": "property/6767906449167516/019e46e5-798a-739d-a17d-922951949384.webp",
        "width": 966,
        "height": 541
      },
      "poi_business_url": "https://hartzellvetservice.vetstreet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10493226740966803586&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hartzell-veterinary-service-charles-w-hartzell-dvm-and-sue-ann-hartzell-dvm",
      "poi_latitude": "40.151432",
      "poi_longitude": "-84.5937728",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-548-4606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8ajPCWVP4gRgsj0GiBun5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_919398b5-06f1-4d8a-b2f6-321440a279d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Green Lawn Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "4220 OH-571, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-7c52-746f-bd47-805a7545c200.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-7c52-746f-bd47-805a7545c200",
        "storage_key": "property/6767906449167516/019e46e5-7c52-746f-bd47-805a7545c200.webp",
        "width": 959,
        "height": 540
      },
      "poi_business_url": "https://www.greenlawnanimalclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9611135725837119281&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "green-lawn-animal-clinic",
      "poi_latitude": "40.1101385",
      "poi_longitude": "-84.6469102",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-548-2875",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7XJTc4LrP4gRMW-WSgWdYYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_accf401a-ba5a-429e-b03a-217ae073bc28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Tony's Barber Shop",
      "poi_type": "Health and Wellness",
      "poi_address": "7665 Greenville-Celina Rd, Greenville, OH 45331, USA",
      "poi_short_description": "Old-school barber shop, run by a father and son duo (also veterans), for men’s cuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-7d10-71ec-a5e6-3690801572f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-7d10-71ec-a5e6-3690801572f5",
        "storage_key": "property/6767906449167516/019e46e5-7d10-71ec-a5e6-3690801572f5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13474509701686752165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tonys-barber-shop",
      "poi_latitude": "40.1391681",
      "poi_longitude": "-84.6147767",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-548-7778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf3kKFSnrP4gRpfOXwy4T_7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_e692e3a2-6100-4fca-994a-6803eda603ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Darke County Veterinary Service, LLC",
      "poi_type": "Health and Wellness",
      "poi_address": "7630 OH-118, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-7d06-73cf-acea-27b974aa4043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-7d06-73cf-acea-27b974aa4043",
        "storage_key": "property/6767906449167516/019e46e5-7d06-73cf-acea-27b974aa4043.webp",
        "width": 1141,
        "height": 1280
      },
      "poi_business_url": "http://www.darkecountyvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6985023984299882464&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "darke-county-veterinary-service-llc",
      "poi_latitude": "40.1398399",
      "poi_longitude": "-84.63836140000001",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-548-0960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn4c2UxvrP4gR4DfHM07K72A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_4dbcb751-27ff-4169-8cf6-93fc7e78177e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "T K Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "1305 Wagner Ave, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-7eac-7448-a0fa-35272552db68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-7eac-7448-a0fa-35272552db68",
        "storage_key": "property/6767906449167516/019e46e5-7eac-7448-a0fa-35272552db68.webp",
        "width": 1280,
        "height": 1005
      },
      "poi_business_url": "https://t-k-nails-greenville.edan.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3763908009372901386&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "t-k-nails",
      "poi_latitude": "40.1219901",
      "poi_longitude": "-84.6196119",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 937-316-5011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGSRlcUfrP4gRCmDreWQWPDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_64eb3478-744c-4c77-9f7a-686b5dcc9e52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Union Street Hairworkx",
      "poi_type": "Health and Wellness",
      "poi_address": "406 Union St, Greenville, OH 45331, USA",
      "poi_short_description": "Full-service salon offering cuts, color, and texturizing services, as well as waxing, and manicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-8ada-74d8-a764-61a2f50bdc5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-8ada-74d8-a764-61a2f50bdc5b",
        "storage_key": "property/6767906449167516/019e46e5-8ada-74d8-a764-61a2f50bdc5b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9284250148644252456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "union-street-hairworkx",
      "poi_latitude": "40.1080345",
      "poi_longitude": "-84.6403711",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-547-1634",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzzmKe3zrP4gRKOvO81FI2IA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_41f663ca-1055-406d-bea8-7430f53272a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Broadway Barber Shop",
      "poi_type": "Health and Wellness",
      "poi_address": "325 S Broadway St, Greenville, OH 45331, USA",
      "poi_short_description": "Barber shop offering haircuts at reasonable prices.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-81bf-76aa-b7be-f8769ef0390f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-81bf-76aa-b7be-f8769ef0390f",
        "storage_key": "property/6767906449167516/019e46e5-81bf-76aa-b7be-f8769ef0390f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2724380370475664030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "broadway-barber-shop",
      "poi_latitude": "40.101982",
      "poi_longitude": "-84.632392",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-548-5581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtcR04Z3sP4gRnsI_N4PxziU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_4fff18f8-051a-42d0-a44c-75a4796e5081",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Hairology Off Broadway",
      "poi_type": "Health and Wellness",
      "poi_address": "215 E 4th St, Greenville, OH 45331, USA",
      "poi_short_description": "Local, neighborhood hair salon providing cuts, color & styling services for men, women & children.",
      "poi_long_description": "Local, neighborhood hair salon providing cuts, color & styling services for men, women & children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-8296-72f8-bcff-62afecc788fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-8296-72f8-bcff-62afecc788fa",
        "storage_key": "property/6767906449167516/019e46e5-8296-72f8-bcff-62afecc788fa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://hairologyoffbroadway.glossgenius.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6607684216009834141&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hairology-off-broadway",
      "poi_latitude": "40.1017461",
      "poi_longitude": "-84.62966229999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-459-5945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98c9-737e-ab43-06bba5c5eac2",
        "storage_key": "property/6767906449167516/019e46e5-98c9-737e-ab43-06bba5c5eac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwb5tZ_sP4gRnb44E8k1s1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_d5622976-7707-40c2-ac90-ff6c22d76fe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Wayne HealthCare",
      "poi_type": "Health and Wellness",
      "poi_address": "835 Sweitzer St, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-8a79-7749-b6be-ec7bb42aade9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-8a79-7749-b6be-ec7bb42aade9",
        "storage_key": "property/6767906449167516/019e46e5-8a79-7749-b6be-ec7bb42aade9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.waynehealthcare.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13749700153559338692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wayne-healthcare",
      "poi_latitude": "40.0887419",
      "poi_longitude": "-84.634558",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 937-548-1141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98e4-75ad-b52e-52ca8395f981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98e4-75ad-b52e-52ca8395f981",
        "storage_key": "property/6767906449167516/019e46e5-98e4-75ad-b52e-52ca8395f981.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWrceZHsP4gRxM4JzXC_0L4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_eaaa6f5f-d56d-4a22-bfbb-883e3a402034",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Turtle Creek Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6545 US-36, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-81dc-7300-ba31-b83f3f523e4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-81dc-7300-ba31-b83f3f523e4c",
        "storage_key": "property/6767906449167516/019e46e5-81dc-7300-ba31-b83f3f523e4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://turtlecreekon36.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12746757563616273550&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "turtle-creek-golf-course",
      "poi_latitude": "40.1068561",
      "poi_longitude": "-84.5597827",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-548-3563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-9927-77c3-8797-5ae57936dad2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-9927-77c3-8797-5ae57936dad2",
        "storage_key": "property/6767906449167516/019e46e5-9927-77c3-8797-5ae57936dad2.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ1eN9H6UP4gRjiRfCXiU5bA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_1cdfc2eb-88d8-4d6c-b041-17562b7edd0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Greenville City Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "108 Ave F, Greenville, OH 45331, USA",
      "poi_short_description": "Relaxed park offering fishing, disc golf, picnic areas and playground equipment such as slides.",
      "poi_long_description": "People say this park is beautiful and well-kept, featuring ponds for fishing, walking paths, and a playground. Visitors also highlight the clean restrooms and picnic areas. They also mention the peaceful atmosphere and the presence of peacocks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-8496-7459-8aca-335147f8c703.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-8496-7459-8aca-335147f8c703",
        "storage_key": "property/6767906449167516/019e46e5-8496-7459-8aca-335147f8c703.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityofgreenville.org/2160/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=17540058421836161029&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "greenville-city-park",
      "poi_latitude": "40.110853",
      "poi_longitude": "-84.629272",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-548-2315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98ca-760b-a8b0-6f15ac6b8635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98ca-760b-a8b0-6f15ac6b8635",
        "storage_key": "property/6767906449167516/019e46e5-98ca-760b-a8b0-6f15ac6b8635.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS75WyGfrP4gRBaAkFTTOavM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2e622469-4098-4cdb-ba80-7994ce45c1f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Shawnee Prairie Preserve & Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4267 OH-502, Greenville, OH 45331, USA",
      "poi_short_description": "Family-friendly preserve featuring walking trails and a nature center with animal exhibits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-84df-72cd-ad4e-8d59e627cf21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-84df-72cd-ad4e-8d59e627cf21",
        "storage_key": "property/6767906449167516/019e46e5-84df-72cd-ad4e-8d59e627cf21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.darkecountyparks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10704237073815728731&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shawnee-prairie-preserve--nature-center",
      "poi_latitude": "40.09873959999999",
      "poi_longitude": "-84.6470794",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 937-548-0165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98ca-760b-a8b0-6f15ac6b8635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98ca-760b-a8b0-6f15ac6b8635",
        "storage_key": "property/6767906449167516/019e46e5-98ca-760b-a8b0-6f15ac6b8635.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyef9TIntP4gRW3JauOcWjZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_b7cf6b6f-3c0a-4d9b-8fad-992ec14e6a3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Gettysburg Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8191 New Harrison-Bradford Rd, Bradford, OH 45308, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-87a2-732e-9b55-b0b7dd7d9df6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-87a2-732e-9b55-b0b7dd7d9df6",
        "storage_key": "property/6767906449167516/019e46e5-87a2-732e-9b55-b0b7dd7d9df6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17228277749649101522&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gettysburg-community-park",
      "poi_latitude": "40.1224443",
      "poi_longitude": "-84.5015423",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98ca-760b-a8b0-6f15ac6b8635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98ca-760b-a8b0-6f15ac6b8635",
        "storage_key": "property/6767906449167516/019e46e5-98ca-760b-a8b0-6f15ac6b8635.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq18ecNqXP4gR0tKZf1UjF-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_40e612db-702c-486f-a6e5-c1e908584f7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "poi_name": "Turkeyfoot Preserve - Darke County Parks",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3957 Bishop Rd, Greenville, OH 45331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-86d5-70fb-975f-55ba2a4d944a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e5-86d5-70fb-975f-55ba2a4d944a",
        "storage_key": "property/6767906449167516/019e46e5-86d5-70fb-975f-55ba2a4d944a.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://www.darkecountyparks.org/turkeyfoot-preserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=14930554236501750771&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "turkeyfoot-preserve---darke-county-parks",
      "poi_latitude": "40.0748649",
      "poi_longitude": "-84.65251719999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 937-548-0165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167516/019e46e5-98ca-760b-a8b0-6f15ac6b8635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e5-98ca-760b-a8b0-6f15ac6b8635",
        "storage_key": "property/6767906449167516/019e46e5-98ca-760b-a8b0-6f15ac6b8635.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmRGWc4DsP4gR8_Nj_vj7M88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    }
  ],
  "office_hours": [
    {
      "id": "ec_fb766b412cdf5f6a43b7a77e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_c53da0bba1c97d481758187e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_51ce6f7d5cd60e3a55414b5c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_c18f6512ed9da503088db961",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "16:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_fa5655fd-75b3-49c0-bd3a-8e8e83a3cbcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "rating": "5.0",
      "name": "Kacie Sims",
      "text": "I had a great experience with the property manager, Kilie, at this property! She was punctual and very precise during the lease and showing of the unit. She actually came in on her day off to show me the unit which is so considerate and kind due to my own schedule. This property is clean and nice overall. A great property manager makes it even better!",
      "date": "2025-01-13",
      "title": ""
    },
    {
      "id": "custom_60a08ea6-3608-4793-9fce-f372e3538438",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "rating": "5.0",
      "name": "Josie Pool",
      "text": "Absolutely love it, the management was Great Trish made me feel very welcomed and at home. She was very informative and kept me updated step by step all the way up toy move-in day. I would recommend this apartment complex to anyone eligible to live here.",
      "date": "2021-08-16",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ed0ea-ca8f-756d-bfa7-0c5fce9ff418",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Hunters Oak Apartments Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516"
    },
    {
      "lead_collector_id": "019ed0ea-cb35-772e-92b7-169750b1e59e",
      "lead_source": "LANDING_PAGE",
      "name": "Hunters Oak Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-greenville-oh",
      "search_query": "pet-friendly apartments in Greenville OH",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Greenville, OH",
      "h2_subtitle": "Discover our pet-friendly community in Greenville. Enjoy spacious living with your furry companions in OH's welcoming neighborhood.",
      "page_copy": "Hunters Oak offers pet-friendly apartments in Greenville, OH. Located in Darke County, the community provides access to nearby parks, walking areas, and local pet-friendly spaces.\nThe apartments include features and layouts designed for everyday living, along with pet-friendly policies that support residents with pets. Hunters Oak is located near shopping, dining, and other local destinations in the Greenville area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Greenville, OH",
      "seo_description": "Discover pet-friendly apartments in Greenville, OH at Hunters Oak. Enjoy spacious living spaces designed with your furry friends in mind. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "apartments-darke-county-in-unit-laundry",
      "search_query": "apartments in Darke County with in-unit laundry",
      "category": "Amenity",
      "h1_title": "Apartments in Darke County with In-Unit Laundry",
      "h2_subtitle": "Explore our modern apartments in Darke County. Enjoy the convenience of in-unit laundry in your new Greenville, OH home.",
      "page_copy": "Hunters Oak offers apartments in Darke County featuring in-unit laundry. The community includes modern apartment layouts designed for everyday living and practical use of space.\nLocated in Greenville, OH, Hunters Oak provides access to nearby shopping, dining, parks, and local destinations. The community offers residential living with in-unit laundry and apartment features designed for daily convenience and functionality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Darke County",
      "seo_description": "Discover Hunters Oak, featuring in-unit laundry apartments in Darke County. Conveniently located in Greenville, OH, our homes offer modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "greenville-oh-apartments-air-conditioning",
      "search_query": "Greenville OH apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Greenville OH Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool in Greenville, OH with our air-conditioned apartments. Discover comfortable living at Hunters Oak.",
      "page_copy": "Hunters Oak offers apartments in Greenville, OH featuring air conditioning. The community features modern apartment layouts designed for everyday living and seasonal temperature control.\nLocated in Darke County, Hunters Oak provides access to nearby shopping, dining, parks, and local destinations in the Greenville area. Residents benefit from a convenient location with practical apartment features and access to surrounding community amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Greenville OH Apartments with Air Conditioning",
      "seo_description": "Stay cool in Greenville, OH with air-conditioned apartments at Hunters Oak. Perfectly located in a welcoming community. Discover today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "apartments-45331-dedicated-parking",
      "search_query": "apartments in 45331 with dedicated parking",
      "category": "Amenity",
      "h1_title": "Apartments in 45331 with Dedicated Parking",
      "h2_subtitle": "Find convenience with dedicated parking in our 45331 apartments. Enjoy hassle-free living in Greenville, OH.",
      "page_copy": "Hunters Oak offers apartments in the 45331 area of Greenville, OH with dedicated parking options available for residents. The community provides convenient on-site parking access along with modern apartment features designed for everyday living.\nLocated in Darke County, Hunters Oak offers access to nearby shopping, dining, and local destinations in the Greenville area. Residents benefit from practical amenities and a residential setting designed to support daily routines.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "45331 Apartments with Dedicated Parking",
      "seo_description": "Discover Hunters Oak apartments in 45331 with dedicated parking. Enjoy hassle-free living in Greenville, OH with convenient accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "greenville-luxury-apartments-dog-parks",
      "search_query": "Greenville luxury apartments near dog parks",
      "category": "Amenity",
      "h1_title": "Luxury Greenville Apartments Near Dog Parks",
      "h2_subtitle": "Enjoy upscale living in Greenville with luxury apartments near dog parks. Perfect for pet lovers.",
      "page_copy": "Hunters Oak offers apartments in Greenville, OH located near local dog parks, providing convenient access to outdoor spaces for pets and their residents. The community features pet-friendly policies and thoughtfully designed apartment layouts with modern amenities for everyday living.\nLocated in Darke County, Hunters Oak provides access to nearby parks, walking areas, shopping, dining, and other local destinations in the Greenville area. Residents can enjoy a residential setting that includes convenient access to outdoor recreation spaces.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Greenville Apartments Near Dog Parks",
      "seo_description": "Discover apartment living at Hunters Oak in Greenville, OH, located near local dog parks. Pet-friendly policies and convenient access to outdoor spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-greenville-oh",
      "search_query": "two bedroom apartments greenville oh",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Greenville, OH",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Hunters Oak in Greenville, OH. These apartments feature comfortable layouts and modern amenities designed for everyday living",
      "page_copy": "Welcome to Hunters Oak, offering spacious two-bedroom apartments in Greenville, OH. Located in Darke County, the community provides convenient access to local shopping, dining, and everyday services in the surrounding area.\nEach two-bedroom apartment features generous layouts and modern amenities designed for everyday living. The community offers a residential setting with easy access to nearby attractions and conveniences throughout Greenville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Greenville, OH",
      "seo_description": "Discover spacious two-bedroom apartments at Hunters Oak in Greenville, OH. These apartments feature functional layouts with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-darke-county",
      "search_query": "three bedroom apartments darke county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Darke County",
      "h2_subtitle": "Discover spacious three-bedroom apartments at Hunters Oak in Darke County.",
      "page_copy": "Hunters Oak offers spacious three-bedroom apartments in Darke County, providing generous layouts designed for everyday living. Located in Greenville, OH, these apartments feature modern amenities and flexible floor plans that support a variety of living arrangements.\nSituated in Darke County, the community provides convenient access to local shopping, dining, and services in the Greenville area. The three-bedroom layouts offer additional living space for those who need extra room for daily activities, home offices, or shared living needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Darke County",
      "seo_description": "Explore spacious three-bedroom apartments at Hunters Oak in Darke County, featuring modern amenities and generous layouts designed for everyday living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "apartments-near-edison-state-community-college-greenville",
      "search_query": "apartments near Edison State Community College Greenville",
      "category": "School",
      "h1_title": "Apartments Near Edison State Community College",
      "h2_subtitle": "Find convenient apartments near Edison State Community College in Greenville, OH. Hunters Oak offers a location with easy access to nearby educational institutions.",
      "page_copy": "Experience convenient living at Hunters Oak with apartments near Edison State Community College in Greenville, OH. Our pet-friendly community offers a location with easy access to campus, as well as nearby shopping, dining, and other local destinations.\nResidents enjoy spacious living areas and modern amenities designed for everyday comfort. Located in Darke County, Hunters Oak provides access to the surrounding Greenville area, supporting a balanced daily routine between home, work, and local activities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Edison State Community College",
      "seo_description": "Convenient living at Hunters Oak, offering apartments near Edison State Community College. Pet-friendly community provides location with easy access to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "apartments-near-wayne-healthcare-greenville",
      "search_query": "apartments near Wayne HealthCare Greenville",
      "category": "Hospital",
      "h1_title": "Apartments Near Wayne HealthCare Greenville",
      "h2_subtitle": "Explore convenient living at Hunters Oak with apartments near Wayne HealthCare in Greenville.",
      "page_copy": "Discover convenient living at Hunters Oak with apartments near Wayne HealthCare in Greenville, OH. Our pet-friendly community offers a location that provides easy access to nearby medical services, shopping, dining, and other local destinations.\nEach apartment features spacious layouts and modern amenities designed for everyday living. Residents can enjoy a residential setting with convenient access to the surrounding Greenville area, supporting a balanced daily routine between home and nearby destinations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wayne HealthCare Greenville",
      "seo_description": "Choose Hunters Oak for convenient and comfortable living with apartments near Wayne HealthCare in Greenville, OH. ",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "apartments-near-greenville-city-park-darke-county",
      "search_query": "apartments near Greenville City Park Darke County",
      "category": "Park",
      "h1_title": "Apartments Near Greenville City Park",
      "h2_subtitle": "Enjoy convenient access to Greenville City Park from Hunters Oak in Darke County. ",
      "page_copy": "Hunters Oak offers apartments near Greenville City Park in Darke County, providing convenient access to outdoor recreation and local attractions. Located just minutes from the park, residents can enjoy walking trails, open green spaces, picnic areas, and other recreational opportunities close to home.\nOur pet-friendly apartments feature spacious floor plans and modern amenities designed for everyday convenience. In addition to nearby parks, Hunters Oak offers easy access to shopping, dining, and entertainment throughout Greenville. Explore a comfortable apartment community with a location that makes it easy to enjoy everything the area has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Greenville City Park",
      "seo_description": "Discover Hunters Oak, offering apartments near Greenville, OH. Enjoy a convenient location in Darke County with easy access to everyday conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167516",
      "source": "custom",
      "page_item_url": "apartments-close-to-gettysburg-community-park-oh",
      "search_query": "apartments close to Gettysburg Community Park OH",
      "category": "Park",
      "h1_title": "Apartments Close to Gettysburg Community Park",
      "h2_subtitle": "Discover the charm of living near Gettysburg Community Park, OH. Perfect for nature lovers seeking a vibrant community.",
      "page_copy": "Hunters Oak offers apartments in Greenville, OH located near Gettysburg Community Park. The community provides convenient access to outdoor recreation areas, walking trails, and local green spaces in the surrounding area.\nThe apartments feature practical layouts and modern amenities designed for everyday living. Located in Darke County, Hunters Oak also provides access to nearby shopping, dining, and other local destinations in Greenville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Gettysburg Community Park",
      "seo_description": "Hunters Oak offers apartments in Greenville, OH located near Gettysburg Community Park. ",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12067653748"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5685515"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P5NHGRQ7"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_tax_credit_properties",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkRTTlpPNlBrZzg3OTlxUmdMQlRXeFE9PSIsInZhbHVlIjoicHJKY2J2VER5NTV4d1BScHBDQTM4Zz09IiwibWFjIjoiY2Q1YzYwYWRlNWFiN2IyYzkzNGMyZjZkZWY5YWM4NTU1ODBmNzc0OTY5ODdkZjQzZjQ5YTYzNzVmMjJmYmZjMCJ9"
    }
  ],
  "custom_repli_id": "12067653748",
  "custom_realpage_id": "5685515",
  "custom_google_gtm_id": "GTM-P5NHGRQ7",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Prestige",
  "custom_tax_credit_properties": "true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkRTTlpPNlBrZzg3OTlxUmdMQlRXeFE9PSIsInZhbHVlIjoicHJKY2J2VER5NTV4d1BScHBDQTM4Zz09IiwibWFjIjoiY2Q1YzYwYWRlNWFiN2IyYzkzNGMyZjZkZWY5YWM4NTU1ODBmNzc0OTY5ODdkZjQzZjQ5YTYzNzVmMjJmYmZjMCJ9",
  "custom_audioeye_site_id": "971d53a6-96cc-4d5c-99c8-5e0091e6c0c7",
  "custom_audioeye_site_hash": "e793b10839a6d77e4ce6a0091c8687a4"
};

export const generatedAt = '2026-09-23T21:42:56.434Z';
